import { createEntityAdapter, createSlice, type EntityState, type PayloadAction } from '@reduxjs/toolkit'

import type { Account, AccountRelationship, User } from './types'

export const accountsAdapter = createEntityAdapter<Account>()
export const usersAdapter = createEntityAdapter<User>()
export const relationshipsAdapter = createEntityAdapter<AccountRelationship>()

export interface DirectoryState {
  accounts: EntityState<Account, string>
  users: EntityState<User, string>
  relationships: EntityState<AccountRelationship, string>
}

export const emptyDirectory = (): DirectoryState => ({
  accounts: accountsAdapter.getInitialState(),
  users: usersAdapter.getInitialState(),
  relationships: relationshipsAdapter.getInitialState(),
})

export const directorySlice = createSlice({
  name: 'directory',
  initialState: emptyDirectory(),
  reducers: {
    /**
     * Replaces the whole directory with what the backend holds: accounts, users and the links between accounts.
     */
    directoryLoaded(state, action: PayloadAction<{ accounts: Account[]; users: User[]; relationships: AccountRelationship[] }>) {
      accountsAdapter.setAll(state.accounts, action.payload.accounts)
      usersAdapter.setAll(state.users, action.payload.users)
      relationshipsAdapter.setAll(state.relationships, action.payload.relationships)
    },
  },
  // The directory belongs to the backend, not to shared browser storage: syncing another tab's saved copy over it would
  // bring back stale data, so `sharedHydrated` is deliberately not handled here.
})

export const { directoryLoaded } = directorySlice.actions
